export default {
  schema__DESTINATION: "Destination",
  schema__CHILD_AGE: "Child age",
  schema__DEPARTURE_AIRPORT: "departure airport",
  schema__DEPART_DATE: "Depart date",
  schema__ERROR_MAX_DATE: (date) => `Please enter a date earlier than ${date}.`,
  schema__ERROR_MIN_DATE: (date) => `Please enter a date after ${date}.`,
  schema__INVALID_DEPART_DATE: "Enter valid depart date",
  schema__INVALID_RETURN_DATE: "Enter valid return date",
  schema__RETURN_DATE: "Return date",
};
